app.filter('steppedRange', function () {
  return function (input, min, max, step) {
    min = parseInt(min); //Make string input int
    max = parseInt(max);

    for (let i = min; i < max; i = i + step) {
      input.push(i);
    }

    return input;
  };
});
